import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup } from '@angular/forms';
import { Admin } from '@mol-limo-reg/admin-api';
import { AddAdminDialogService } from '../add-admin-dialog/add-admin-dialog.service';
import { AddAdminFormGroup, AdminDialogType } from '../add-admin-dialog/add-amin-dialog.vm';

@Component({
  selector: 'app-add-admin-dialog',
  templateUrl: './edit-admin-dialog.component.html',
  styleUrls: ['./edit-admin-dialog.component.scss'],
  providers: [AddAdminDialogService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditAdminDialogComponent implements OnInit {
  protected editAdminFormGroup: FormGroup<AddAdminFormGroup> | undefined;
  protected passwordVisible = false;

  constructor(private readonly addAdminDialogService: AddAdminDialogService, @Inject(MAT_DIALOG_DATA) public data: Admin) {}

  public ngOnInit(): void {
    this.editAdminFormGroup = this.addAdminDialogService.getAddAdminFormGroup(AdminDialogType.Edit, this.data);
  }

  public togglePasswordVisible() {
    this.passwordVisible = !this.passwordVisible;
  }

  public onSubmit() {
    if (this.editAdminFormGroup?.valid) {
      this.addAdminDialogService.updateForm(this.data);
    } else {
      this.editAdminFormGroup?.markAllAsTouched();
    }
  }
}
